<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="tile">
  <div class="row align-items-center" [class.mb-4]="dialogMode === 'showFaq'">
    <div class="col-12 col-md-6 col-lg-9 mb-2 mb-md-0">
      <h1 class="zero-text p-huge-med">{{ 'tickets.list.headline' | transloco }}</h1>
    </div>
    <div class="col-12 col-md-6 col-lg-3 text-right">
      <web-design-system-button [fullwidth]="true" (click)="dialogMode = 'showFaq'">
        {{ 'tickets.list.question-button' | transloco }}
      </web-design-system-button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      @if (dialogMode === 'showFaq') {
        <tickets-zendesk-faq-search (createTicket)="dialogMode = 'createTicket'" />
      } @else if (dialogMode === 'createTicket') {
        <div class="row mb-4 mt-2">
          <div class="col">
            <tickets-create-ticket (ticketCreationState)="ticketCreationStateUpdate($event)" />
          </div>
        </div>
      }
    </div>
  </div>
</div>

<div class="tile">
  <div class="row align-items-center mb-4">
    <div class="col-6 col-lg-9">
      <h1 class="zero-text p-huge-med">{{ 'tickets.headline' | transloco }}</h1>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="nav nav-tabs">
        @for (status of allowedStatus; track $index) {
          <div class="nav-item">
            <a class="nav-link" [class.active]="currentStatus === status" (click)="changeCategory(status)">
              {{ 'tickets.nav.' + status | transloco }}
              @if (status !== 'CLOSED' && ticketFacade.unreadTicketsCount$ | async; as unreadTicketsCount) {
                <span class="badge badge-pill badge-alert">{{ unreadTicketsCount }}</span>
              }
            </a>
          </div>
        }
      </div>

      <div class="row">
        <div class="col-12">
          <table class="table-tickets" @onlyEnter>
            <caption>
              {{
                'tickets.headline' | transloco
              }}
            </caption>
            <tbody>
              <tr>
                <th class="cursor-pointer">
                  &nbsp;<br />
                  <span [ngClass]="sorter.getSorterClasses('after', 'subject')" (click)="sortBy('subject')">
                    {{ 'tickets.list.subject' | transloco }}
                  </span>
                </th>
                <th>
                  <span
                    class="cursor-pointer text-no-wrap"
                    [ngClass]="sorter.getSorterClasses('before', 'created')"
                    (click)="sortBy('created')"
                  >
                    {{ 'tickets.list.created' | transloco }}
                  </span>
                  <br />
                  <span class="cursor-pointer" [ngClass]="sorter.getSorterClasses('before', 'updated')" (click)="sortBy('updated')">
                    {{ 'tickets.list.modified' | transloco }}
                  </span>
                </th>
                <th>
                  <span
                    class="cursor-pointer text-no-wrap"
                    [ngClass]="sorter.getSorterClasses('before', 'status')"
                    (click)="sortBy('status')"
                  >
                    {{ 'tickets.list.status' | transloco }}
                  </span>
                  <br />
                  <span
                    class="cursor-pointer text-no-wrap"
                    [ngClass]="sorter.getSorterClasses('before', 'author')"
                    (click)="sortBy('author')"
                  >
                    {{ 'tickets.list.author' | transloco }}
                  </span>
                </th>
              </tr>

              @if (ticketFacade.ticketsInitiallyLoaded$ | async) {
                @if (tickets?.length) {
                  @for (t of tickets; track t.id) {
                    <tr [id]="'ticket-' + t.id">
                      <td>
                        <div class="d-flex">
                          <div class="hidden-md hidden-lg hidden-xl mr-5">
                            {{ 'tickets.list.subject' | transloco }}
                          </div>
                          <div>
                            <a
                              class="link-primary cursor-pointer"
                              [ngClass]="t.status === 'CLOSED' ? '' : 'font-bold'"
                              (click)="toggleTicketDetails(t)"
                              >#{{ t.deskTicket?.ticketNumber ? t.deskTicket.ticketNumber : '---' }}: {{ t.subject }}</a
                            >
                          </div>
                        </div>
                        @if (ticketsToShow[t.id]) {
                          <tickets-show-ticket-thread
                            [ticket]="t"
                            [currentUser]="currentUser$ | async"
                            (ticketChanged)="onTicketChanged()"
                            [lastTicketLoad]="ticketsLastLoaded"
                          />
                        }
                      </td>
                      <td>
                        <div class="d-flex justify-content-end text-no-wrap">
                          <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                            {{ 'tickets.list.created' | transloco }}
                          </div>
                          <div [ngClass]="t.status === 'CLOSED' ? '' : 'font-bold'">
                            {{ t.created | date: 'dd.MM.yyyy HH:mm:ss' }}
                          </div>
                        </div>
                        <div class="d-flex justify-content-end text-no-wrap">
                          <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                            {{ 'tickets.list.modified' | transloco }}
                          </div>
                          <div [ngClass]="t.status === 'CLOSED' ? '' : 'font-bold'">
                            {{ t.updated | date: 'dd.MM.yyyy HH:mm:ss' }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-end text-no-wrap">
                          <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                            {{ 'tickets.list.status' | transloco }}
                          </div>
                          <div [ngClass]="t.status === 'CLOSED' ? '' : 'font-bold'">
                            {{ t.status | displayLabel }}
                          </div>
                        </div>
                        <div class="d-flex justify-content-end align-items-center">
                          <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                            {{ 'tickets.list.author' | transloco }}
                          </div>
                          <div class="font-size-smaller2" [ngClass]="t.status === 'CLOSED' ? '' : 'font-bold'">
                            {{ t.author }}
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                } @else {
                  <tr>
                    <td colspan="3">{{ 'tickets.empty.' + currentStatus | transloco }}</td>
                  </tr>
                }
              }
              @if ((ticketFacade.ticketsLoading$ | async) === true) {
                <tr>
                  <td>
                    <div class="loading-shimmer"></div>
                  </td>
                  <td>
                    <div class="loading-shimmer"></div>
                  </td>
                  <td>
                    <div class="loading-shimmer"></div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex flex-grow justify-content-end mb-2 mt-2">
    <a [class.hidden]="(ticketFacade.ticketsHasNext$ | async) === false" (click)="showMore()" class="cursor-pointer link-secondary">
      {{ 'tickets.more' | transloco }} <span class="sorter-after-flat sorter-after-flat--down"></span>
    </a>
  </div>
</div>
